import React from "react";

const ActionOptionCard = ({
  title,
  subtitle,
  icon,
  isSelected,
  isRecommended,
  onClick,
}) => {
  let bgStyle = "#F8FAFC";
  let borderStyle = "1px solid #E2E8F0";
  let titleColor = "#475569";
  let iconBg = "#E2E8F0";
  let iconColor = "#64748B";

  if (isSelected) {
    if (isRecommended) {
      bgStyle = "#F0FDF4";
      borderStyle = "1.5px solid #22C55E";
      titleColor = "#15803D";
      iconBg = "#DCFCE7";
      iconColor = "#16A34A";
    } else {
      bgStyle = "#FFF7F2";
      borderStyle = "1.5px solid #EA580C";
      titleColor = "#C2410C";
      iconBg = "#FFEDD5";
      iconColor = "#EA580C";
    }
  } else {
    bgStyle = "#F8FAFC";
    borderStyle = "1px solid #E2E8F0";
    titleColor = "#475569";
    iconBg = "#E2E8F0";
    iconColor = "#64748B";
  }

  const iconWithProps = React.isValidElement(icon)
    ? React.cloneElement(icon, {
        color: iconColor,
        style: { ...(icon.props.style || {}), color: iconColor },
      })
    : icon;

  return (
    <div className="col-md-6">
      <div
        className="position-relative p-3 p-md-4 cursor-pointer h-100 d-flex flex-column justify-content-center transition-all"
        style={{
          border: borderStyle,
          backgroundColor: bgStyle,
          borderRadius: "20px",
          cursor: "pointer",
          boxShadow: isSelected
            ? isRecommended
              ? "0 4px 14px rgba(34, 197, 94, 0.12)"
              : "0 4px 14px rgba(234, 88, 12, 0.12)"
            : "none",
          transition: "all 0.2s ease-in-out",
        }}
        onClick={onClick}
      >
        <div className="d-flex align-items-center justify-content-between w-100 mb-2">
          <div className="d-flex align-items-center gap-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: "48px",
                height: "48px",
                backgroundColor: iconBg,
                transition: "all 0.2s ease-in-out",
              }}
            >
              {iconWithProps}
            </div>

            <h6
              className="fw-bold mb-0"
              style={{
                color: titleColor,
                fontSize: "17px",
                lineHeight: "1.3",
                transition: "color 0.2s ease-in-out",
              }}
            >
              {title}
            </h6>
          </div>

          {isRecommended && (
            <div className="flex-shrink-0 ms-2">
              <span
                className="badge rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"
                style={{
                  backgroundColor: isSelected ? "#DCFCE7" : "#FFFFFF",
                  color: isSelected ? "#15803D" : "#64748B",
                  fontSize: "12px",
                  fontWeight: "500",
                  border: isSelected
                    ? "1px solid #BBF7D0"
                    : "1px solid #94A3B8",
                  transition: "all 0.2s ease-in-out",
                }}
              >
                <span>موصى به</span>
                <span
                  style={{
                    fontSize: "11px",
                    color: isSelected ? "#15803D" : "#64748B",
                  }}
                >
                  ★
                </span>
              </span>
            </div>
          )}
        </div>

        {isSelected && subtitle && (
          <div
            className="w-100"
            style={{
              paddingRight: "60px",
              fontSize: "13px",
              lineHeight: "1.4",
            }}
          >
            {typeof subtitle === "string" ? (
              <p className="text-muted mb-0">{subtitle}</p>
            ) : (
              subtitle
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionOptionCard;
